import { useAgenticAiContext } from "@services/useAgenticAiContext";
import { useCanUseOperator } from "@services/useCanUseOperator";
import { useFeatureOn } from "@services/useFeatureOn";

/**
 * Returns whether the Agentic AI chat interface should be rendered inline.
 *
 * When the `sage_ai_agentic_inline_everywhere` feature flipper is enabled,
 * always returns true - the Operator will be inline and displace page content.
 * Otherwise, only returns true for the email_composer context.
 */
export const useInlineAgenticChat = (): boolean => {
  const { contextIdentifiers } = useAgenticAiContext();
  const featureOn = useFeatureOn();
  const canUseOperator = useCanUseOperator();

  // Return true when the feature flipper is enabled and the user can use the operator
  if (featureOn("sage_ai_agentic_inline_everywhere") && canUseOperator) {
    return true;
  }

  // Default behavior: inline for email_composer and line editors
  return (
    !!contextIdentifiers.email_composer || !!contextIdentifiers.line_composer || !!contextIdentifiers.line_editor
  );
};
